import apiClient from './apiClient';

const feedbackSend = (
  name: string,
  phone: string,
  message: string
): Promise<void> =>
  apiClient
    .post('api/feedback/send', { name, phone, message })
    .then((r) => r.data);

export { feedbackSend };
